import { AnySessionPart, SessionEvent } from "@/mds/components/sessions/session.types";
import { get, isArray, isString, uniqueId } from "lodash-es";

export const parseSessionPartsFromEvent = ({
  event,
}: {
  event: SessionEvent;
}): AnySessionPart[] => {
  const parts = get(event, "data.value.parts");

  if (isArray(parts)) {
    return parts as AnySessionPart[];
  }

  return [];
};

/**
 * Resolve the ID of a session event part.
 * (Older parts didn't have IDs set, so we have a fallback in-place.)
 */
export const resolveSessionPartId = ({ part }: { part: AnySessionPart }) => {
  const partId = get(part, "id") as string | undefined;

  if (isString(partId) && partId.length > 0) {
    return partId;
  }

  const fallbackId = uniqueId("fallback-part-id-");
  return fallbackId;
};
